import { decodeOneOf, encodeOneOf } from '../../../../../domain';
import { CompaniesKeys } from '../companies.key';
import { Places } from '../../../../route-consts';
/** Prefixo dos nomes deste arquivo na intencao - unico na aplicacao (ver `url-codes.test.ts`). */
const PREFIX = 'cc';
/** Os parametros deste place: vao para o endereco. */
const P = {
    /** Que confirmacao esta aberta. Ver `COMPANY_ACTION_CODES`. */
    Action: `${PREFIX}a`
};
/** O codigo de cada confirmacao no endereco. Ver `CodeTable` em `domain`. */
export const COMPANY_ACTION_CODES = {
    '0': 'block',
    '1': 'delete',
    '2': 'unblock'
};
/**
 * Uma confirmacao, que tambem e um place.
 *
 * `#/hub/companies/confirm?empresa=5&acao=delete` - o Voltar cancela, o que e
 * exatamente o que se espera de uma confirmacao, e nao custou handler nenhum.
 */
export class CompanyConfirmKeys extends CompaniesKeys {
    get place() {
        return Places.companyConfirm;
    }
    get action() {
        return decodeOneOf(this._intent.getParameterAsString(P.Action), COMPANY_ACTION_CODES, 'block');
    }
    set action(value) {
        this._intent.setParameter(P.Action, encodeOneOf(value, COMPANY_ACTION_CODES));
    }
}
//# sourceMappingURL=company-confirm.key.js.map